<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("lookups/getDepartments");

        this.$store
            .dispatch("employees/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
            }).catch(() => { });
    },
    computed: {
        departments() {
      return  this.$store.state.lookups.departments;

    }
    },
    data() {
        return {
            vm: {
        fullName: null,
        jobDescription: null,
        departmentId: null,
        phoneNo: null,
      },
        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("employees/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>